import { render, staticRenderFns } from "./ChartMostLoyalCustomers.vue?vue&type=template&id=652fd8ac"
import script from "./ChartMostLoyalCustomers.vue?vue&type=script&lang=js"
export * from "./ChartMostLoyalCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports